import { useLocationSearch } from '@rocketlane/rocket-router';
import { useMemo } from 'react';

export const useHeadlessMode = (): boolean => {
  const search = useLocationSearch();

  const isHeadless = useMemo(() => {
    const params = new URLSearchParams(search);

    return params.get('snapshot') === 'true';
  }, [search]);

  return isHeadless;
};
